export enum BadgePlacements {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  TR = 'topRight',
}
export enum TriggerEnums {
  CLICK = 'click',
  HOVER = 'hover',
  POPOVER_BG = '#072945',
  TITLE = 'Click title',
}
export enum ButtonLabels {
  SKIP = 'Skip',
  PREVIOUS = 'Previous',
  SAVE_AND_PROCEED = 'Submit & Proceed',
  NEXT = 'Next',
  BACK = 'Back',
  CANCEL = 'Cancel',
}

export enum PopoverProps {
  CLICK_CONTENT = 'This is the click content',
}
